interface FlaggedSummary {
  account_id: string;
  display_name: string;
  cpl_delta_pct: number | null;
}

interface Props {
  active: number;
  last_checked_at: string | null;
  flagged?: FlaggedSummary[];
}

function formatHoursAgo(iso: string | null): string {
  if (!iso) return "—";
  const hours = Math.max(1, Math.round((Date.now() - new Date(iso).getTime()) / 3600000));
  return `${hours}h`;
}

export function AlertBanner({ active, last_checked_at, flagged = [] }: Props) {
  const isHealthy = active === 0;

  if (isHealthy) {
    const ago = formatHoursAgo(last_checked_at);
    return (
      <div
        style={{
          padding: "10px 14px",
          borderRadius: 4,
          fontSize: "var(--fs-sm)",
          marginBottom: "var(--space-4)",
          background: "rgba(109,191,120,0.06)",
          borderLeft: "3px solid #6dbf78",
          display: "flex",
          alignItems: "center",
          gap: 8,
        }}
      >
        {/* Inline green dot — one-off, not importing StatusDot to keep this component self-contained */}
        <span
          style={{
            display: "inline-block",
            width: 8,
            height: 8,
            borderRadius: "50%",
            backgroundColor: "#6dbf78",
            flexShrink: 0,
          }}
        />
        <span>
          All accounts healthy &middot; last checked {ago} ago
        </span>
      </div>
    );
  }

  // active > 0
  const plural = active === 1 ? "" : "s";
  let message = `${active} account${plural} need attention`;

  if (flagged.length > 0) {
    const items = flagged.slice(0, 3).map((f) => {
      if (f.cpl_delta_pct === null) return f.display_name;
      const sign = f.cpl_delta_pct >= 0 ? "+" : "";
      return `${f.display_name} ${sign}${Math.round(f.cpl_delta_pct)}%`;
    });
    message += ` — ${items.join(", ")}`;
  }

  return (
    <div
      style={{
        padding: "10px 14px",
        borderRadius: 4,
        fontSize: "var(--fs-sm)",
        marginBottom: "var(--space-4)",
        background: "rgba(217,100,92,0.12)",
        borderLeft: "3px solid #d9645c",
      }}
    >
      {message}
    </div>
  );
}
